import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { AssetPhotoState } from '@leid/api-assets'
import { OrderItem } from '@leid/api-orders'

import { AssetPhotoUploadRequest } from 'appTypes/api-requests/assets'
import { Button as LeidButton } from 'components/ui/Buttons/Button'
import LeidModal from 'components/ui/Modal/LeidModal'
import apiClient from 'helpers/clients/apiClient'

import CameraCapture from './CameraCapture'

interface Props {
  orderItem: OrderItem
  imageText?: string
}

const CameraModal = (props: Props): JSX.Element => {
  const { orderItem } = props
  const [imageUrl, setImageUrl] = React.useState<Blob | string | undefined>(undefined)
  const [open, setOpen] = useState(false)
  const [uploaded, setUploaded] = useState(false)
  const { t } = useTranslation('common')

  const handleOpen = () => {
    setOpen(true)
    //Refresh state:
    setUploaded(false)
    setImageUrl(undefined)
  }

  const handleClose = () => setOpen(false)

  const uploadImageToServer = async (imageUrl: Blob | string | undefined) => {
    const imageUploadRequest: AssetPhotoUploadRequest = {
      imageUrl: imageUrl,
      bucketName: 'asset-photos',
      state: AssetPhotoState.EMPTY,
      assetId: orderItem?.assetId,
      // employeeId: user?.id,
      productId: orderItem?.productId,
      customerId: orderItem?.customerId,
      orderId: orderItem?.orderId,
      orderItemId: orderItem?.id,
    }

    const response = await apiClient.uploadAssetImage(imageUploadRequest)
    if (response) {
      setUploaded(true)
    }
  }

  return (
    <>
      <button onClick={handleOpen} style={{ padding: 0 }}>
        <img src="/icons/camera.svg" alt="Camera" />
      </button>

      <LeidModal
        isOpen={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        header={t('takePhoto')}
        size={{ base: 'cover', md: 'xl' }}
      >
        <Box>
          <CameraCapture imageUrl={imageUrl} uploaded={uploaded} setImageUrl={setImageUrl} />
          {imageUrl && !uploaded && (
            <LeidButton onClick={() => uploadImageToServer(imageUrl)}>{t('uploadImage')}</LeidButton>
          )}
          <Box display="flex" justifyContent="center">
            {uploaded && <Text>{t('imageUploaded')}</Text>}
          </Box>
        </Box>
      </LeidModal>
    </>
  )
}

export default CameraModal
